"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeSkuProductFactory = makeSkuProductFactory;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
/**
 * make loyalty product factory
 * @param {Function} convertAndFormat convert and format price util
 * @param {String} currentCurrency currently selected currency
 * @returns {Function} loyaltyProductFactory
 */
function makeSkuProductFactory(convertAndFormat, skusPrices) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return "" + x;
    };
  }
  if (skusPrices === void 0) {
    skusPrices = [];
  }
  return function (currentSku) {
    var _skusPrices;
    var sku = (_skusPrices = skusPrices) === null || _skusPrices === void 0 ? void 0 : _skusPrices.find(function (skuPrice) {
      return "" + skuPrice.skuId === currentSku.id;
    });
    return (0, _extends2["default"])({}, currentSku, {
      itemPrice: convertAndFormat(currentSku.itemPrice),
      total: convertAndFormat(currentSku.total),
      title: sku.title
    });
  };
}